import React, { useEffect, useState } from "react";
import {
  FormControl,
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Grid,
  Button,
  TextField,
  TablePagination
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector, connect } from "react-redux";
import DateRangeIcon from "@material-ui/icons/DateRange";
import HttpService from "../services/httpService";
import { setLoading, setSnackInfo } from "../redux/actions/appAction";
import EditIcon from "@material-ui/icons/Edit";
import { useDispatch } from 'react-redux';
import { setMonthlyConversionGoal } from "../redux/actions/leadSourceActions";

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
    border: "1px solid #ddd",
  },
  tableCell: {
    textAlign: "center",
    border: "1px solid #ddd",
    wordWrap: "break-word",
    maxWidth: "150px",
    padding: "8px",
  },
  downloadButton: {
    backgroundColor: "#355025",
    color: "#FFF2EB",
    marginLeft: 10,
    "&:hover": {
      backgroundColor: "#4A6641",
    },
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  submitButton: {
    backgroundColor: "#F47E46 !important", // Decorpot Orange
    color: "white",
    "&:hover": { backgroundColor: "#E0663D !important" }, // Darker Orange on hover
  },
   heading:{
    fontWeight: '600',
    fontSize: '17px',
  },
  title: {
    marginBottom: theme.spacing(2),
    fontWeight: "bold",
    fontSize: "1.5rem",
    textAlign: "center",
  },
   cellStyle: {
    padding: 10,
    width: 500,
    textAlign: "center",
    fontWeight: 700,
    backgroundColor: "#1C375D",
    color: "white",
  },
}));

function MonthlyConversionGoals(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const monthlyConversionData = useSelector((state) => state.leadSource.monthlyConversionData);  
  const { userDetails } = useSelector((state) => state.user);
  const [allExperienceCenters, setAllExperienceCenters] = useState([]);
  const [monthlyData, setMonthlyData] = useState([])
  const [startDate, setStartDate]= useState(null);
  const [endDate, setEndDate]= useState(null);
  const [editData, setEditData] = useState();
  const [editModal, setEditModal] = useState(false);
  const [goalUpdates, setGoalUpdates] = useState({});
  const [rowsPerPage, setRowsPerPage]= useState(25);
  const [page, setPage] = useState(0);
  const [totalData, setTotalData] = useState(0);
  const [isDisabled, setIsDisabled] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);
  const [isSpinning, setIsSpinning] = useState(false);
  const EIGHT_BUTTON_DISABLE_UNTIL_KEY = 'eightButton_disableUntil';
  const [toggleForceCall, setToggleForceCall] = useState(false)

  // Fetch experience centers
  const getExperienceCenters = async () => {
    try {
      props.setLoading(true);
      const res = await HttpService.getAllExperienceCenter();
      const sortedCenters = (res.data?.data || []).sort((a, b) =>
        a.name.localeCompare(b.name)
      );
      setAllExperienceCenters(sortedCenters || []);
      props.setLoading(false);
    } catch (err) {
      props.setLoading(false);
      props.setSnackInfo("Failed to fetch experience centers.");
    }
  };

  useEffect(() => {
    getExperienceCenters();
    getMonthlyData();
  }, [startDate, endDate, page, rowsPerPage, toggleForceCall]);

  // Add this effect to initialize state from localStorage and handle timer
  useEffect(() => {
    const disableUntilTimestamp = localStorage.getItem(EIGHT_BUTTON_DISABLE_UNTIL_KEY);

    if (disableUntilTimestamp) {
      const now = new Date().getTime();
      const disableUntil = parseInt(disableUntilTimestamp, 10);

      if (disableUntil > now) {
        const remainingTimeInSeconds = Math.ceil((disableUntil - now) / 1000);
        setTimeLeft(remainingTimeInSeconds);
        setIsDisabled(true);
      } else {
        localStorage.removeItem(EIGHT_BUTTON_DISABLE_UNTIL_KEY);
        setIsDisabled(false);
        setTimeLeft(0);
      }
    }

    // Set up timer to update remaining time
    let timer;
    if (isDisabled && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft(prevTime => {
          const newTime = prevTime - 1;
          if (newTime <= 0) {
            // When time is up, clear localStorage and enable button
            localStorage.removeItem(EIGHT_BUTTON_DISABLE_UNTIL_KEY);
            setIsDisabled(false);
            return 0;
          }
          return newTime;
        });
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [isDisabled, timeLeft]);

  const getMonthlyData = async () => {
    try {
      props.setLoading(true);
      let obj = {
        startDate: startDate,
        endDate: endDate,
        page: page,
        rowsPerPage: rowsPerPage
      };

      let shouldMakeApiCall = false;
      // Case 1: No salesData - must call API
      if (!monthlyConversionData || monthlyConversionData === null || monthlyConversionData.length === 0) {
        shouldMakeApiCall = true;
      }

      if (shouldMakeApiCall || toggleForceCall) {
        let res = await HttpService.getMonthlyConversionGoalsData(obj);
        setMonthlyData(res.data.data);
        dispatch(setMonthlyConversionGoal(res.data.data));  
        localStorage.setItem("totalConversionGoal", String(res.data.total));
        setTotalData(res.data.total);
        setToggleForceCall(false); 
      } else {
        setMonthlyData(monthlyConversionData);
         const stored = localStorage.getItem("totalConversionGoal");
        setTotalData(parseInt(stored));
      }
      props.setLoading(false);
    } catch (err) {
      console.error(err);
    }
  };


  // handle Date filter SUbmit
  const handleDateFilterData = async () => {
    try {
      props.setLoading(true);
      let obj = {
        startDate: startDate,
        endDate: endDate,
        page: page,
        rowsPerPage: rowsPerPage
      }
      const res = await HttpService.getMonthlyConversionGoalsData(obj);
      setMonthlyData(res.data.data);
      setTotalData(res.data.total);
      props.setLoading(false);
    }
    catch (err) {
      console.error(err);
    }
  }

  //  New feature for update data
  const handleClickEdit = (data)=>{
    setEditData(data);
    setEditModal(true);
  }
 
  // handle Update conversion goal
  const handleUpdateGoalData = async (expCenter) => {
    try {
      setEditModal(false);
      const updateArray = [];
      Object.entries(goalUpdates).forEach(([key, value]) => {
        const [index, yearStr, month, goalType] = key.split("-");
        const year = parseInt(yearStr);

        const numericValue = Number(value);

        // Try to find existing object with same year and month
        let existing = updateArray.find(
          (item) => item.year === year && item.month === month
        );

        if (!existing) {
          existing = {
            year,
            month,
            expCenter: expCenter,
            leadToMeetingGoal: 0,
            meetingToOrderGoal: 0,
            leadToOrderGoal: 0,
          };
          updateArray.push(existing);
        }
        existing[goalType] = numericValue;
      });

      let res = await HttpService.updateConversionGoal(updateArray);
      if (res.status === 200) {
        props.setSnackInfo('Updated Successfully', 'success')
      }
      getMonthlyData();
    } catch (err) {
      console.error(err);
      props.setSnackInfo('Something went wrong', 'error')
    }
  };

  // handle change goal value
  const handleInputChange = (index, year, month, field, value) => {
    setGoalUpdates(prev => ({
      ...prev,
      [`${index}-${year}-${month}-${field}`]: value
    }));
  };

  // pagination function
  const handleChangePage = (event, newPage) => {
        dispatch(setMonthlyConversionGoal([]));
        setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        dispatch(setMonthlyConversionGoal([]));
    };

  // Replace your existing handleRefreshClick with this
  const handleRefreshClick = () => {
    dispatch(setMonthlyConversionGoal([]));
    setToggleForceCall(true);
    const disableUntilTimestamp = new Date().getTime() + (4 * 60 * 1000);
    localStorage.setItem(EIGHT_BUTTON_DISABLE_UNTIL_KEY, disableUntilTimestamp.toString());
    setIsDisabled(true);
    setTimeLeft(240); 
    setIsSpinning(true);
    setTimeout(() => {
      setIsSpinning(false);
    }, 1000);
  };

  // Format time for display
  const formatTimeLeft = () => {
    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  return (
    <div>
      <div className={classes.header}>
        <Typography variant="h4" className={classes.title}>
            Monthly Conversion % Goals: Previous Months and Current
        </Typography>
      </div>
      <Paper className={classes.paper} style={{ marginBottom: "20px" }}>
        {/* Start Date and End Date */}
        <Grid container spacing={2} alignItems="center" justifyContent="center">
          <Grid item xs={12} sm={3}>
            <FormControl style={{ width: "100%", marginTop: "0.4rem" }}>
              <TextField
                label="Start Date"
                type="month"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className={classes.dateField}
                variant="outlined"
                fullWidth
                InputProps={{
                  startAdornment: <DateRangeIcon color="action" />,
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={3}>
            <FormControl style={{ width: "100%", marginTop: "0.4rem" }}>
              <TextField
                label="End Date"
                type="month"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className={classes.dateField}
                variant="outlined"
                fullWidth
                size="sx"
                InputProps={{
                  startAdornment: <DateRangeIcon color="action" />,
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </FormControl>
          </Grid>
          {/* Filter Submit button */}
          <Grid item xs={12} sm={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleDateFilterData()}
              className={classes.submitButton}
              disabled={!startDate || !endDate}
            >
              Submit
            </Button>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Button
              onClick={handleRefreshClick}
              variant="contained"
              disabled={isDisabled}
              style={{
                backgroundColor: isDisabled ? "#cccccc" : "#F47E46",
                color: "#FFF2EB",
                padding: "8px 16px"
              }}
            >
              {isDisabled
                ? `Wait (${formatTimeLeft()})`
                : "Fetch New Data"}
            </Button>
          </Grid>
        </Grid>
      </Paper>


      {monthlyData?.length > 0 && (
        <>
        <Table>
          <TableHead>
              <TablePagination
                rowsPerPageOptions={[25, 50, 100, 200, 500, { label: 'All', value: totalData  }]}
                colSpan={monthlyData[0]?.data?.length + 3}
                count={totalData}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: { 'aria-label': 'rows per page' },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                style={{ flexShrink: 0 }}
              />
            <TableRow>
              <TableCell className={classes.cellStyle}>Experience Center</TableCell>
              <TableCell className={classes.cellStyle}>Stages</TableCell>
              {monthlyData[0]?.data?.map((data, index) => (
                <TableCell key={index} className={classes.cellStyle}>
                  {`${data?.month}- ${String(data?.year).slice(-2)}`}
                </TableCell>
              ))}
             <TableCell className={classes.cellStyle}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {monthlyData
              ?.sort((a, b) =>
                a.experienceCenterName.localeCompare(b.experienceCenterName)
              )
              ?.map((item, idx) => (
                <React.Fragment key={idx}>
                  
                  <TableRow>
                     <TableCell
                      rowSpan={3}
                      style={{
                        backgroundColor: "#f0f0f0",
                        fontWeight: "bold",
                        textAlign: "center",
                      }}
                      component='th'
                    >
                      {item.experienceCenterName}
                    </TableCell>
                    <TableCell component='th' style={{ textAlign: "center", fontWeight: "bold" }}>
                      Lead To Meeting
                    </TableCell>
                    {item?.data?.map((data, index) => (
                      <TableCell component='th' key={index} style={{ textAlign: "center" }}>
                        {`${data?.leadToMeetingGoal}%`}
                      </TableCell>
                    ))}
                     <TableCell
                      rowSpan={3}
                      style={{
                        backgroundColor: "#f0f0f0",
                        fontWeight: "bold",
                        textAlign: "center",
                      }}
                      component='th'
                    >
                      <EditIcon style={{ color: "#F47E46", cursor: "pointer" }}
                         onClick={()=>handleClickEdit(item)}
                      />
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell component='th' style={{ textAlign: "center", fontWeight: "bold" }}>
                      Meeting To Order
                    </TableCell>
                    {item?.data?.map((data, index) => (
                      <TableCell component='th' key={index} style={{ textAlign: "center" }}>
                        {`${data?.meetingToOrderGoal}%`}
                      </TableCell>
                    ))}
                  </TableRow>

                  <TableRow>
                    <TableCell component='th' style={{ textAlign: "center", fontWeight: "bold" }}>
                      Lead To Order
                    </TableCell>
                    {item?.data?.map((data, index) => (
                      <TableCell component='th' key={index} style={{ textAlign: "center" }}>
                        {`${data?.leadToOrderGoal}%`}
                      </TableCell>
                    ))}
                  </TableRow>
                </React.Fragment>
              ))}
          </TableBody>
          </Table>
        </>
      )}

      {/* Dialog for Edit Button Click */}
      <Dialog
        open={editModal}
        onClose={() => setEditModal(false)}
        aria-labelledby="form-dialog-title"
        maxWidth="lg"
        PaperProps={{
          style: {
            width: "100%", 
            maxHeight: "80vh",
          },
        }}
      >
        <DialogTitle id="form-dialog-title">
          <h4>Set Monthly Conversion % Goal for {editData?.experienceCenterName}</h4>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Table>
          <TableHead>
            <TableRow>
              <TableCell className={classes.cellStyle}>Sl. No</TableCell>
              <TableCell className={classes.cellStyle}>Month</TableCell>
             <TableCell className={classes.cellStyle}></TableCell>
             <TableCell className={classes.cellStyle}></TableCell>
             <TableCell className={classes.cellStyle}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
              {editData?.data?.map((data, index) => (
                <TableRow>
                  <TableCell component='th' style={{textAlign: 'center'}}>{index + 1}</TableCell>
                  <TableCell component='th' style={{textAlign: 'center'}} key={index}>
                    {`${data?.month}- ${String(data?.year).slice(-2)}`}
                  </TableCell>
                   <TableCell component="th">
                    <FormControl style={{ width: 250 }}>
                      <TextField
                        size="small"
                        label="Lead to Meeting %"
                        type="number"
                        name="leadToMeeting"
                        id="leadToMeeting"
                        variant="outlined"
                        value={goalUpdates[`${index}-${data.year}-${data.month}-leadToMeetingGoal`] ?? data.leadToMeetingGoal}
                        onChange={(e) =>
                          handleInputChange(index, data.year, data.month, "leadToMeetingGoal", e.target.value)
                        }
                      />
                    </FormControl>
                  </TableCell>
                     <TableCell component="th">
                    <FormControl style={{ width: 250 }}>
                      <TextField
                        size="small"
                        label="Meeting to Order %"
                        type="number"
                        name="meetingToOrder"
                        id="meetingToOrder"
                        variant="outlined"
                        value={goalUpdates[`${index}-${data.year}-${data.month}-meetingToOrderGoal`] ?? data.meetingToOrderGoal}
                        onChange={(e) =>
                          handleInputChange(index, data.year, data.month, "meetingToOrderGoal", e.target.value)
                        }
                      />
                    </FormControl>
                  </TableCell>
                   <TableCell component="th">
                    <FormControl style={{ width: 250 }}>
                      <TextField
                        size="small"
                        label="Lead to Order %"
                        type="number"
                        name="leadToOrder"
                        id="leadToOrder"
                        variant="outlined"
                        value={goalUpdates[`${index}-${data.year}-${data.month}-leadToOrderGoal`] ?? data.leadToOrderGoal}
                        onChange={(e) =>
                          handleInputChange(index, data.year, data.month, "leadToOrderGoal", e.target.value)
                        }
                      />
                    </FormControl>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
          </Table>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>setEditModal(false)} variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={() => handleUpdateGoalData(editData?.experienceCenterName)}
            variant="contained"
            color="primary"
            className={classes.submitButton}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default connect(null, { setLoading, setSnackInfo })(
  MonthlyConversionGoals
);